const SLUG_MAX_LENGTH = 15
export const generateSlug = (value: string, maxLength: number = SLUG_MAX_LENGTH): string => {
    return value
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .substring(0, maxLength)
}

const WORDS_TO_REMOVE = [
    'school',
    'institute',
    'academy',
    'learning',
    'higher',
    'secondary',
    'primary',
    'elementary',
    'public',
    'private',
    'international',
    'national',
    'state',
    'government',
    'govt',
    'center',
    'centre',
    'organization',
    'org',
    'corp',
    'corporation',
    'inc',
    'incorporated',
    'ltd',
    'limited',
    'management',
    'training',
    'of',
    'and',
    'development',
    'services',
    'solutions',
    'systems',
    'technology',
    'tech',
    'international',
    'main',
    'central',
]
export const generateSubdomain = (
    institutionName: string,
    maxLength: number = SLUG_MAX_LENGTH,
): string => {
    return institutionName
        .toLowerCase()
        .split(/\s+/)
        .filter(word => !WORDS_TO_REMOVE.includes(word.trim()))
        .join(' ')
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
        .substring(0, maxLength)
}
